export default "__VITE_ASSET__DlJL8N1d__"